export default __webpack_public_path__ + "static/media/constellation_4.3094efcf.png";